import {
	DiamondsSection,
	EarnPerHourSection,
	TotalCoinsSection,
} from './components';

interface CoinsInfoProps {}

export const CoinsInfo: React.FC<CoinsInfoProps> = ({}: CoinsInfoProps) => {
	/*********************
	// #region Constants
	**********************/
	const hasTotalCoinsEnabled = process.env.VITE_ENABLE_TOTAL_COINS;
	const hasDiamondsEnabled = process.env.VITE_ENABLE_DIAMONDS;

	/*********************
	// #region Template
	**********************/
	return (
		<div
			className={`${
				hasTotalCoinsEnabled && hasDiamondsEnabled
					? 'min-w-[300px]'
					: 'min-w-[230px]'
			} mx-auto`}
		>
			<div className="flex justify-between items-center rounded-full bg-vottun-950/50 px-4 py-2 text-[9px] text-center mb-2">
				<EarnPerHourSection />

				{hasTotalCoinsEnabled && (
					<>
						<div className="w-px self-stretch bg-gray-900"></div>
						<TotalCoinsSection />
					</>
				)}

				{hasDiamondsEnabled && (
					<>
						<div className="w-px self-stretch bg-gray-900"></div>
						<DiamondsSection />
					</>
				)}
			</div>
		</div>
	);
};
